'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.on = on;
exports.off = off;
exports.ready = ready;
exports.getProtocol = getProtocol;
exports.guid = guid;
exports.isObject = isObject;
exports.isURL = isURL;
exports.timestamps = timestamps;
exports.objectToUrl = objectToUrl;
/**
 * 绑定事件
 * @param {object}   elem 元素
 * @param {string}   type 事件类型
 * @param {function} callback 回调
 */
function on(elem, type, callback) {
  if (elem.addEventListener) {
    elem.addEventListener(type, callback);
  } else {
    elem.attachEvent('on' + type, function () {
      callback.call(elem);
    });
  }
}

/**
 * 绑定事件
 * @param {object}   elem 元素
 * @param {string}   type 事件类型
 * @param {function} callback 回调
 */
function off(elem, type, callback) {
  if (elem.removeEventListener) {
    elem.removeEventListener(type, callback);
  } else {
    elem.attachEvent('off' + type, callback);
  }
}

/**
 * DOM渲染完成
 * @param {function} fn
 */
function ready(fn) {
  if (document.readyState !== 'loading') {
    fn();
  } else if (document.addEventListener) {
    document.addEventListener('DOMContentLoaded', fn);
  } else {
    document.attachEvent('onreadystatechange', function () {
      if (document.readyState !== 'loading') {
        fn();
      }
    });
  }
}

/**
 * 获取协议url
 * @param  {string} url  链接
 * @return {string}
 */
function getProtocol() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href;

  return (/^https/i.test(url) ? 'https' : 'http'
  );
}

/**
 * 唯一标识符
 * @param {string} 返回标识
 */
function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}

/**
 * 判断是否是对象
 * @param {string} str
 * @return {boolean}
 */
function isObject(str) {
  return Object.prototype.toString.call(str) === '[object Object]';
}

/**
 * 判断是不是带协议的网址（//开头或者包含://）
 * @return {boolean}
 */
function isURL(url) {
  return (/^\/\//.test(url) || /^[a-zA-z]+:\/\/[^\s]*/.test(url)
  );
}

/**
 * 生成时间戳
 */
function timestamps() {
  return +new Date();
}

/**
 * 对象转url参数
 * @param {*} obj
 */
function objectToUrl(obj) {
  if (!isObject(obj)) {
    return '';
  }

  var str = '';
  Object.keys(obj).map(function (key, index) {
    str += '' + (index === 0 ? '?' : '&') + key + '=' + encodeURIComponent(obj[key]);
  });

  return str;
}


// WEBPACK FOOTER //
// ./lib/utils.js